var ClearSessionCookies, Logout, LogoutCampaign, PopupCenter, checkLicenseValidity, checkPasswordAge, checkServerMessages, closeProgress, db, getURLParameter, hidevisualizeobjects, instance, isTableView, loginRequest, pad, progress, setMapTableViewHeight, showdashboard, toogleLocation, updatePassword;

instance = window.instance;

window.isloginsucess = false;

db = window.db;

loginRequest = void 0;

isTableView = false;

progress = false;


/*
Close the progress Dialog
 */

closeProgress = function() {
  progress = false;
  return $("#progress-modal").modal("hide");
};


/*
Display the progress Dialog
 */

$(document).ready(function() {
  var isIE;
  isIE = false || !!document.documentMode;
  if (isIE) {
    $('#browsertype').html('IE not supported, please use some other bowser.');
  }
  if (window.location.pathname.indexOf('online-survey') === -1 && window.userName.indexOf('campaign') !== -1) {
    LogoutCampaign();
  }
  if (logout === "true") {
    Logout();
  }
  if (upgrade === "true") {
    showUpgradeDialog();
  }
  if ((typeof showScheduler !== "undefined" && showScheduler !== null) && showScheduler === "true") {
    return $('#main-navigation .schedule a').click();
  }

  /*
  
   * if user-id isn't equal to null, it means that the user has successfully logged-in.
  if userID?
  
      #$("#loginScr")[0].style.cssText = "display:none;"; // hide the login screen
      #$("#index")[0].style.cssText = "" # display the main screen
      #$(".nameLabel").html userName this is now embedded in the header.jsp file
  
      if window.clientPersistModel? and window.clientPersistModel.get("showDataAutomatically")
        $(".autoload").each (i, el) ->
          $(el).prop "checked", "checked"
  
      if window.clientPersistModel? and window.clientPersistModel.get("rememberFilterSelections")
        $(".sessionDiv").each (i, el) ->
          $(el).prop "checked", "checked"
  
      if window.clientPersistModel? and window.clientPersistModel.get("clusterMap")
        $(".clusterMap").each (i, el) ->
          $(el).prop "checked", "checked"
  
  
  if roles.indexOf("admin") isnt -1
      $(".form-builder").show()
      $(".admin_link").show()
      $(".offline-form-builder").show()
  
   else if roles.indexOf("modeler") isnt -1
      $(".form-builder").show()
      $(".offline-form-builder").show()
  
  if roles? and (roles.indexOf("admin") isnt -1 or roles.indexOf("modeler") isnt -1)
      if roles.indexOf("admin") isnt -1
          $(".admin_link").show()
  
      $(".form-builder").show()
      $(".offline-form-builder").show()
  
  if db is "tearfund" and userID?
      $(".dashboard_link").show()
  else
      $(".dashboard_link").hide()
   */

  /* registration now on RegisterView
  $(".agreepolicy").each (i, el) ->
      $(el).prop "checked", ""
      $("#registerbutton").prop("disabled",true);
   */

  /*
  $("#langSelect").change (evt)->
      val = $(this).val()
      window.lang = val
      window.clientPersistModel.save {
        "lang": val
      }
      window.location = window.location.pathname + "?lang=#{val}"
  
  
  
  $(".dropdown-menu select").click (evt)->
      evt.stopPropagation()
   */

  /*
  $('#headerMenu').overflowNavs
    'more': "#{messages.more}"
    'parent': '.nav-collapse'
    'override_width': true
  
  if (window.location.host.indexOf("situpro") != -1 ) and $("#scheduleMenu").length > 0
    $("#scheduleMenu").hide()
   */
});

ClearSessionCookies = function() {};

getURLParameter = function(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [,''])[1].replace(/\+/g, '%20')) || null;
};

Logout = function() {
  var JSON;
  if (typeof userID !== "undefined" && userID !== null) {
    showProgress();
    document.getElementById("progressMessage").innerHTML = "Logging out..";
    if (typeof clientPersistModel !== "undefined" && clientPersistModel !== null) {
      if (clientPersistModel.get("fromDate") === null || clientPersistModel.get("fromDate") === undefined || clientPersistModel.get("fromDate") === "") {
        clientPersistModel.set("fromDate", "");
      }
      if (clientPersistModel.get("toDate") === null || clientPersistModel.get("toDate") === undefined || clientPersistModel.get("toDate") === "") {
        clientPersistModel.set("toDate", "");
      }
    }
    if (typeof clientPersistModel !== "undefined" && clientPersistModel !== null) {
      JSON = "{ \"user_id\" : \"" + userID + "\" , \"userName\" : \"" + userName + "\" , \"users\" : \"" + (clientPersistModel.get("users").join(",")) + "\" , \"locations\" : \"" + (clientPersistModel.get("locations")) + "\" , \"forms\" : \"" + (clientPersistModel.get("forms").join(",")) + "\" , \"dates\" : \"" + (clientPersistModel.get("fromDate")) + ";" + (clientPersistModel.get("toDate")) + "\", \"loadSession\" : \"" + (clientPersistModel.get("rememberFilterSelections")) + "\", \"loadDataAutomatically\" : \"" + (clientPersistModel.get("showDataAutomatically")) + "\", \"clustermap\" : \"" + (clientPersistModel.get("clusterMap")) + "\", \"chartVid\" : \"" + (clientPersistModel.get("chartVid")) + "\", \"lang\" : \"" + (clientPersistModel.get("lang")) + "\"}";
    } else {
      JSON = "{ \"user_id\" : \"" + userID + "\" , \"userName\" : \"" + userName + "\" , \"users\" : \"\" , \"locations\" : \"\" , \"forms\" : \"\" , \"dates\" : \";\", \"loadSession\" : \"false\", \"loadDataAutomatically\" : \"true\", \"clustermap\" : \"false\", \"chartVid\" : \"false\", \"lang\" : \"en\"}";
    }
    return $.ajax({
      type: "POST",
      url: baseUrl + "auth/logout",
      data: JSON,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        var lang;
        $("#downloads").hide();
        googleSignOut();
        window.instance = result;
        lang = getURLParameter('lang');
        if (lang !== null && lang !== "null") {
          return window.location = "/login.jsp?lang=" + lang;
        } else {
          return window.location = "/login.jsp";
        }
      },
      complete: function() {
        return closeProgress();
      },
      error: function(error) {
        return handleError(error);
      }
    });
  }
};

LogoutCampaign = function() {
  var JSON;
  if (typeof userID !== "undefined" && userID !== null) {
    showProgress();
    document.getElementById("progressMessage").innerHTML = "Finalizing Survey";
    JSON = "{ \"user_id\" : \"" + userID + "\" , \"userName\" : \"" + userName + "\" , \"isCampaign\" : \"true\" , \"users\" : \"" + (clientPersistModel.get("users").join(",")) + "\"}";
    showProgress();
    return $.ajax({
      type: "POST",
      url: baseUrl + "auth/logout",
      data: JSON,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        return window.location = "/surveythankyou.jsp";
      },
      complete: function() {
        window.location = "/surveythankyou.jsp";
        return closeProgress();
      },
      error: function(error) {
        return handleError(error);
      }
    });
  }
};

window.instance = instance;

window.loginRequest = loginRequest;

$(window).load(function(e) {
  checkLicenseValidity();
  checkPasswordAge();
  return checkServerMessages();
});

checkLicenseValidity = function() {
  if (typeof userID !== "undefined" && userID !== null) {
    return $.ajax({
      type: "POST",
      url: baseUrl + "app/data/checklicense/" + userID,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        if (result.status === "WARNING" || result.status === "EXPIRED") {
          return bootbox.alert(result.message);
        }
      }
    });
  }
};

checkPasswordAge = function() {
  if (typeof userID !== "undefined" && userID !== null) {
    return $.ajax({
      type: "POST",
      url: baseUrl + "app/data/checkpassword/" + userID,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        if (result.status === "EXPIRED" || result.status === "WARNING") {
          updatePassword(result.useremail);
          if (result.message === "passwordExpired") {
            $("#password-warning").html("<br/><div class='panel panel-danger'><div class='panel-body'><font color=\"red\"><b>" + messages.passwordExpired + "</div></div>");
          } else if (result.message === "firstLogin") {
            $("#password-warning").html(" <br/><div class='panel panel-warning'><div class='panel-body'><b>" + messages.firstLogin + "</div></div> ");
          }
          $("#cancelPassword").hide();
          return $(".modal-dialog").removeAttr("style");
        }
      }
    });
  }
};

checkServerMessages = function() {
  if (typeof userID !== "undefined" && userID !== null) {
    return $.ajax({
      type: "POST",
      url: baseUrl + "app/data/checkmessages",
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      success: function(result) {
        if (result.status === "MESSAGE") {
          return bootbox.alert(result.message);
        }
      }
    });
  }
};

$("#btn-up").on("click", function(evt) {
  $("#questionNameSelected option:selected").each(function() {
    var newPos;
    newPos = $("#questionNameSelected option").index(this) - 1;
    if (newPos > -1) {
      $("#questionNameSelected option").eq(newPos).before("<option value='" + $(this).val() + "' selected='selected'>" + $(this).text() + "</option>");
      return $(this).remove();
    }
  });
  return evt.preventDefault();
});

$("#btn-down").on("click", function(evt) {
  var countOptions;
  countOptions = $("#questionNameSelected option").size();
  $("#questionNameSelected option:selected").each(function() {
    var newPos;
    newPos = $("#questionNameSelected option").index(this) + 1;
    if (newPos < countOptions) {
      $("#questionNameSelected option").eq(newPos).after("<option value='" + $(this).val() + "' selected='selected'>" + $(this).text() + "</option>");
      return $(this).remove();
    }
  });
  return evt.preventDefault();
});

updatePassword = function(useremail) {
  var changePasswordView;
  changePasswordView = new poimapper.views.ChangePasswordView({
    useremail: useremail
  });
  return changePasswordView.render();
};

setMapTableViewHeight = function() {};

$(window).resize(function() {
  return setMapTableViewHeight();
});

toogleLocation = function() {
  if ($("#locationareacontent").hasClass("smallHeight")) {
    $("#locationareacontent").removeClass("smallHeight");
    return $("#locationareacontent").addClass("largeHeight");
  } else {
    $("#locationareacontent").removeClass("largeHeight");
    return $("#locationareacontent").addClass("smallHeight");
  }
};

PopupCenter = function(pageURL, title, w, h) {
  var left, targetWin, top;
  left = (screen.width / 2) - (w / 2);
  top = (screen.height / 2) - (h / 2);
  return targetWin = window.open(pageURL, title, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
};

showdashboard = function(id) {
  if (id === "clientrecord") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FClient_Record_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "dossierdelacliente") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FDossier_De-La_Cliente_Forme&j_username=tearfund&j_password=tearfund";
  }
  if (id === "MonthlyClinicData") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FMonthly_Clinic_Data_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "MonthlyReportCoordinator") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FMonthly_Report_Coordinator_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "RealtimefundraisingForm") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FReal_time_fundraising_Form_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "MonthlyReportMB") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FMonthly_Report_MB_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZClient_Details") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTZ_Client_Details_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZFomuYaPOI") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Fomu_ya_POI_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZGroupInformationForm") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Group_Information_Form_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZMaelezoYaKundi") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Maelezo_ya_Kundi_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZMahaliPaMajiNaUsafiWaMazingira") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Mahali_pa_Maji_na_Usafi_wa_Mazingira_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZMonthlyReportCoordinator") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Monthly_Report_Coordinator_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZMonthlyReportHP") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Monthly_Report_HP_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZPointOfInterest") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Point_of_Interest_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZRipotiYakilaMweziHP") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FViews&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FViews%2FTz_Ripoti_ya_kila_mwezi_HP_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZRipotiYaMratibu") {
    hidevisualizeobjects(0);
    document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FViews&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FViews%2FTz_Ripoti_ya_Mratibu_Form&j_username=tearfund&j_password=tearfund";
  }
  if (id === "TZWaterPointsSanitation") {
    hidevisualizeobjects(0);
    return document.getElementById('jasperframe').src = "//jasper.poimapper.com/jasperserver-pro/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&ParentFolderUri=%2Forganizations%2Forganization_1%2Ftearfund%2FReports&reportUnit=%2Forganizations%2Forganization_1%2Ftearfund%2FReports%2FTz_Water_Points_Sanitation_Form&j_username=tearfund&j_password=tearfund";
  }
};

hidevisualizeobjects = function(param) {
  if (param === 0) {
    $('#jasperframe').show();
    $('#jaspertablediv').hide();
    $('#jasperobjects').hide();
  }
  if (param === 1) {
    $('#jasperframe').hide();
    $('#jaspertablediv').show();
    $('#jasperobjects').hide();
  }
  if (param === 2) {
    $('#jasperframe').hide();
    $('#jaspertablediv').hide();
    return $('#jasperobjects').show();
  }
};

pad = function(value) {
  if (value < 10) {
    value = "0" + value;
  }
  return value;
};

//# sourceMappingURL=maps/ui.js.map
